import { render, staticRenderFns } from "./marshall_outings.vue?vue&type=template&id=52a9612e&scoped=true"
import script from "./marshall_outings.vue?vue&type=script&lang=js"
export * from "./marshall_outings.vue?vue&type=script&lang=js"
import style0 from "./marshall_outings.vue?vue&type=style&index=0&id=52a9612e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9612e",
  null
  
)

export default component.exports